<!-- 首屏 -->
<template>
  <div :class="$style.overview">
    <!-- 顶栏 -->
    <overview-top style="z-index: 1; position: relative;" @login="onLogin" />
    <!-- 导航栏 -->
    <overview-nav
      style="position: fixed; bottom: 0; left: 0; right: 0; z-index: 10;"
      @change="onNavChange"
    />
  </div>
</template>

<script>
import OverviewTop from "./OverviewTop";
import OverviewNav from "./OverviewNav";

export default {
  name: "TheOverview",
  components: { OverviewTop, OverviewNav },
  methods: {
    onNavChange() {
      this.$el.scrollIntoView();
    },
    onLogin() {
      this.$emit("login");
    }
  }
};
</script>

<style lang="less" module>
.overview {
  z-index: 100;
  position: absolute;
  width: 100%;
}
</style>
